import React from "react"

const Divider = ({ className }) => <div className={`w-full h-[1px] bg-white-0 my-4 ${className}`} />

export default Divider;